"use client";

import { AnimatePresence, motion } from "framer-motion";
import { cn } from "@routecore/core";

export type Toast = { id: number; message: string; tone: "ok" | "info" | "warn" | "error" };

export function Toasts({ toasts }: { toasts: Toast[] }) {
  return (
    <div className="pointer-events-none fixed right-5 bottom-5 z-[95] flex flex-col items-end gap-2">
      <AnimatePresence>
        {toasts.map((t) => (
          <motion.div
            key={t.id}
            layout
            initial={{ opacity: 0, y: 14, scale: 0.94 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, scale: 0.94 }}
            transition={{ type: "spring", bounce: 0.3, duration: 0.5 }}
            className="flex items-center gap-2.5 rounded-full bg-ink py-2.5 pr-5 pl-4 text-sm font-semibold text-porcelain shadow-lifted"
          >
            <span
              className={cn(
                "size-2 rounded-full",
                t.tone === "ok"
                  ? "bg-[#3FB97F]"
                  : t.tone === "warn"
                    ? "bg-amber-400"
                    : t.tone === "error"
                      ? "bg-red-500"
                      : "bg-accent",
              )}
            />
            {t.message}
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}
